import DeviceList from "./DeviceList.vue";

const deviceListCtrl = new Vue({
    el: '#device-list',
    components: {DeviceList},
})

